oyc.News = {
  dependencies: ['Pager'],
  container: '.news-list',
  item: '.news-content',
  collapseBtn: '.js-collapse-btn',
  textContainer: '.news-content--text',
  imageContainer: '.image-figure',
  headerContainer: '.news-content--header',
  sublineContainer: '.news-content--subline',
  toggleClass: 'show',
  collapsedClass: 'is-collapsed',
  isAnimating: false,
  textOpen: 'mehr anzeigen',
  textClose: 'Ansicht schließen',
  mobileBreakpoint: 769,
  resizeTimer: null,

  init: function () {
    this.container = $(this.container);

    if (this.container.length > 0) {
      this.calculateTextHeights();
      this.bindEvents();
      this.handleResize();
      this.bindPagerEvents();
    }
  },

  isMobile: function () {
    return $(window).width() < this.mobileBreakpoint;
  },

  getAvailableTextHeight: function ($newsItem) {
    var $article = $newsItem.closest('article');
    var $imageFigure = $article.find(this.imageContainer);
    var $header = $newsItem.find(this.headerContainer);
    var $subline = $newsItem.find(this.sublineContainer);

    var imageHeight = 0;
    var headerHeight = 0;
    var sublineHeight = 0;
    var contentPadding = 0;

    if ($imageFigure.length > 0) {
      imageHeight = $imageFigure.outerHeight(true);
    }

    if ($header.length > 0) {
      headerHeight = $header.outerHeight();
      var headerMarginBottom = parseFloat($header.css('margin-bottom')) || 0;
      headerHeight += headerMarginBottom;
    }

    if ($subline.length > 0) {
      sublineHeight = $subline.outerHeight();
      var sublineMarginBottom = parseFloat($subline.css('margin-bottom')) || 0;
      sublineHeight += sublineMarginBottom;
    }

    var paddingTop = parseFloat($newsItem.css('padding-top')) || 0;
    var paddingBottom = parseFloat($newsItem.css('padding-bottom')) || 0;
    contentPadding = paddingTop + paddingBottom;

    var availableHeight = imageHeight - headerHeight - sublineHeight - contentPadding;

    return availableHeight > 30 ? availableHeight : 30;
  },

  calculateTextHeights: function () {
    var self = this;

    $(this.item).each(function () {
      var $item = $(this);
      var $textContainer = $item.find(self.textContainer);
      var isExpanded = $item.hasClass(self.toggleClass);

      if ($textContainer.length > 0) {
        $textContainer.css('max-height', 'none');

        var fullTextHeight = $textContainer[0].scrollHeight;
        var maxAllowedHeight = self.getAvailableTextHeight($item);

        $item.data('max-allowed-height', maxAllowedHeight);
        $item.data('full-text-height', fullTextHeight);

        if (fullTextHeight > maxAllowedHeight) {
          $item.addClass(self.collapsedClass);

          if (!isExpanded) {
            $textContainer.css('max-height', maxAllowedHeight + 'px');
          } else {
            $textContainer.css('max-height', 'none');
          }
        } else {
          $item.removeClass(self.collapsedClass);
          $textContainer.css('max-height', 'none');
        }
      }
    });
  },

  handleResize: function () {
    var self = this;
    var previousWidth = $(window).width();

    $(window).on('resize', function () {
      var currentWidth = $(window).width();
      var wasDesktop = previousWidth >= self.mobileBreakpoint;
      var isDesktop = currentWidth >= self.mobileBreakpoint;

      clearTimeout(self.resizeTimer);

      if (wasDesktop !== isDesktop) {
        self.calculateTextHeights();
        previousWidth = currentWidth;
      } else {
        self.resizeTimer = setTimeout(function () {
          self.calculateTextHeights();
          previousWidth = currentWidth;
        }, 250);
      }
    });
  },

  bindEvents: function () {
    var self = this;

    this.container.on('click', this.collapseBtn, function (e) {
      e.preventDefault();

      if (self.isAnimating) {
        return;
      }

      self.isAnimating = true;

      var $button = $(this);
      var $clickedItem = $button.closest(self.item);
      var $textContainer = $clickedItem.find(self.textContainer);
      var isActive = $clickedItem.hasClass(self.toggleClass);

      $(self.item).removeClass(self.toggleClass);
      $(self.collapseBtn).attr('aria-expanded', 'false');

      $(self.item).each(function () {
        var $item = $(this);

        if (!$item.hasClass(self.collapsedClass)) {
          return;
        }

        var $text = $item.find(self.textContainer);
        var maxHeight = $item.data('max-allowed-height');

        if (maxHeight) {
          $text.css('max-height', maxHeight + 'px');
        }
      });

      $(self.collapseBtn + '.button-link').text(self.textOpen);

      if (!isActive) {
        $clickedItem.addClass(self.toggleClass);
        $textContainer.css('max-height', 'none');

        $clickedItem.find(self.collapseBtn).attr('aria-expanded', 'true');

        if ($button.hasClass('button-link')) {
          $button.text(self.textClose);
        }
      }

      setTimeout(function () {
        self.isAnimating = false;
      }, 300);
    });
  },

  bindPagerEvents: function () {
    var self = this;
    var $pageableContainer = this.container.closest('.pageable-container');

    if ($pageableContainer.length > 0) {
      $pageableContainer.on('oyc-pager-append-items', function (event, result) {
        setTimeout(function () {
          var $newItems = $pageableContainer.find('.list-item').slice(-result[Object.keys(result)[0]].length);
          self.initNewItems($newItems);
        }, 150);
      });
    }
  },

  refresh: function () {
    this.calculateTextHeights();
  },

  initNewItems: function ($newItems) {
    var self = this;

    $newItems.find(this.item).addBack(this.item).each(function () {
      var $item = $(this);
      var $textContainer = $item.find(self.textContainer);

      if ($textContainer.length > 0) {
        $textContainer.css('max-height', 'none');

        var fullTextHeight = $textContainer[0].scrollHeight;
        var maxAllowedHeight = self.getAvailableTextHeight($item);

        $item.data('max-allowed-height', maxAllowedHeight);
        $item.data('full-text-height', fullTextHeight);

        if (fullTextHeight > maxAllowedHeight) {
          $item.addClass(self.collapsedClass);
          $textContainer.css('max-height', maxAllowedHeight + 'px');
        } else {
          $item.removeClass(self.collapsedClass);
          $textContainer.css('max-height', 'none');
        }
      }
    });
  },

  destroy: function () {
    $(window).off('resize');
    this.container.off('click', this.collapseBtn);
    this.container.closest('.pageable-container').off('oyc-pager-append-items');
    clearTimeout(this.resizeTimer);
  }
};
